import React, { useState } from 'react';
import Button from '../Button/Button';
import DealCreateCarsModal from '../../pages/Deal/DealCreate/DealCreateCarsModal';
import reassignCar from '../../api/deals/reassignCar';
import alert from '../../helpers/alert';

/**
 * Замена машины в сделке — доступна всегда перед выбором оффера банка, не только
 * для просроченных (TTL) сделок. Правит тот же Order (тот же chunkId), новую
 * сделку не создаёт. Подбор ограничен той же комплектацией и цветом, что и у
 * исходной машины.
 */
const ReassignCarButton = ({ orderId, complectationId, color, onDone }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!orderId) return null;

  const handleSubmit = async (cars) => {
    // Таблица (Cars -> Table) отдаёт сырые строки ответа /shop/getItems, там id.
    // Поле value есть только у SelectCars, это другой компонент.
    const newCarId = cars?.[0]?.id;
    if (!newCarId) {
      return alert.error('Выберите автомобиль');
    }

    setLoading(true);
    try {
      await reassignCar({ orderId, newCarId });
      setIsOpen(false);
      onDone?.();
    } catch (e) {
      alert.error(e?.response?.data?.errorMessage || 'Не удалось заменить машину');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button text="Заменить машину" onClick={() => setIsOpen(true)} disabled={loading} />
      {isOpen && (
        <DealCreateCarsModal
          isOpen={isOpen}
          onCancel={() => setIsOpen(false)}
          onClose={() => setIsOpen(false)}
          onSubmit={handleSubmit}
          defaultQueryParams={{ stock: true, complectationId, color }}
        />
      )}
    </>
  );
};

export default ReassignCarButton;
